<template>
  <div class="k-table">
    <el-table style="width: 100%" :show-header="showHeader" :data="data.Items" :max-height="maxheight" :height="height" highlight-current-row @row-click="handleRowClick" @cell-click="handleCellClick" ref="table">
      <slot>
      </slot>
    </el-table>
    <div class="k-table-pager">
      <el-pagination @size-change="handlePageSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="pageSizes" :page-size="currentPageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: 'k-table',
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          Items: [],
          PageSize: 10,
          TotalRecords: 0
        }
      }
    },
    currentPageSize: {
      type: Number,
      default: 10
    },
    maxheight: Number,
    height: Number,
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      currentPage: 1,
      pageSizes: [10, 15, 20],
      total: this.totalRecords,
      selectedRow: null
    }
  },
  computed: {
    totalRecords: function () {
      return this.data.TotalRecords;
    }
  },
  watch: {
    data: function (curVal, oldVal) {
      // 当前页码
      if (curVal && curVal.CurrentPage > 0) { this.currentPage = curVal.CurrentPage; }
      this.total = this.data.TotalRecords;
    }
  },

  methods: {
    handleCurrentChange(currentPage) {
      this.$emit('CurrentPageBeforeChange');
      let pageSize = this.currentPageSize;
      this.currentPage = currentPage;
      let loadParam = {
        page: currentPage,
        pageSize: pageSize
      };
      this.$emit('CurrentPageAfterChange', loadParam);
    },

    handlePageSizeChange(pageSize) {
      this.$emit('PageSizeBeforeChange');
      let currentPage = this.currentPage;
      this.currentPageSize = pageSize;
      let loadParam = {
        page: currentPage,
        pageSize: pageSize
      };
      this.$emit('PageSizeAfterChange', loadParam);
    },

    handleRowClick(selection) {
      this.selectedRow = selection;
      this.$emit('RowClick', selection);
    },

    handleCellClick(row, column, cell, event) {
      this.$emit('CellClick', row, column, cell);
    },

    // 列样式
    tableRowClassName(row, index) {
      if (index % 2 === 1) {
        return 'odd';
      } else if (index % 2 === 0) {
        return 'even';
      }
      return '';
    }

  }
}

</script>

<style lang="scss" scoped>
.k-table-pager {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/table/src/table.vue